import { getLodop } from '@/plugins/LodopFuncs.js';
// import { cloneDeep } from 'lodash';
// import { currentDate } from '@/utils/filter';

export default {
	data() {
		return {
			record: { // 病历处方
        patient: {
          patientName: '',
        },
        inquiryInfo: {
          diagnosisResultString: '',
        },
        medicineDrugPrescriptionList: [
          {
            patientDrugList: []
          }
        ]
      },
      printShow: false,
      scriptList: {},
      review: false, // 是否开启打印预览
		}
	},
	methods: {
    // 打印处方
    printScript() {
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      // 在门诊功能时取当前医生名
      this.record.realName = this.$store.state.global.countInfo.realName;
      const { additionalList, examList, medicineDrugPrescriptionList, patientChineseDrugList, patientInfusionList, patientStickingDrugGroupList } = this.record;
      // 有没有填写数据 没有拦截做出提示
      if ( additionalList.length === 0 &&
        examList.length === 0 &&
        medicineDrugPrescriptionList.length === 0 &&
        patientChineseDrugList.length === 0 &&
        patientInfusionList.length === 0 &&
        patientStickingDrugGroupList.length === 0) {
        return;
      }
      this.$notify({
        title: '提示',
        message: '正在打印请稍后...',
        type: 'success',
      });
      if (medicineDrugPrescriptionList.length > 0) this.$refs.medicinePrint.print();
      if (patientChineseDrugList.length > 0) this.$refs.piecesPrint.print();
      if (patientInfusionList.length > 0) this.$refs.infusionPrint.print();
      if (patientStickingDrugGroupList.length > 0) this.$refs.applyPrint.print();
      if (examList.length > 0 || additionalList.length > 0) this.$refs.otherPrint.print();
    },
    printMedicalRecord() {
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      this.$notify({
        title: '提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.$refs.recordPrint.print();
    },
    // 打印输液卡
    printInfusionCard() {
      const LODOP = getLodop();
      if (!LODOP) {
        this.printShow = true;
        return;
      }
      this.$notify({
        title: '提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.$refs.infusionCardPrint.print();
    },
	},
};
